import { render, staticRenderFns } from "./tproperty-mapping.vue?vue&type=template&id=017b8c94&"
import script from "./tproperty-mapping.vue?vue&type=script&lang=ts&"
export * from "./tproperty-mapping.vue?vue&type=script&lang=ts&"
import style0 from "./tproperty-mapping.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports